import { render, staticRenderFns } from "./addReference.vue?vue&type=template&id=71cb07f0&scoped=true"
import script from "./addReference.vue?vue&type=script&lang=js"
export * from "./addReference.vue?vue&type=script&lang=js"
import style0 from "./addReference.vue?vue&type=style&index=0&id=71cb07f0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71cb07f0",
  null
  
)

export default component.exports